export default __webpack_public_path__ + "static/media/masterc_logo.67be1e20.png";